export const SCOPES = {
  TREATMENT: 'treatment',
  PROVIDER: 'provider',
  SERVICE: 'service',
  OPERATION: 'operation',
  PORTAL: 'portal',
  ARCHIVE: 'archive'
};
